import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { convertDate } from "@Services/luxonHelper";
import UserNameTagComponent from "@CubeComponents/html/UserNameTagComponent";
import { useTranslation } from "@i18n";
import { RootState } from "@Reducers/index";

function RevisionContent({ resourceId }: any) {
  const { t } = useTranslation();
  const fileVersions = useSelector((state: RootState) => state.fileVersions[resourceId]);
  const [revisions, setRevisions] = useState<any[]>([]);

  useEffect(() => {
    if (fileVersions && fileVersions.length) {
      const allFileVersionRevisions = fileVersions
        .filter((fileVersion: any) => fileVersion.revision)
        .map((fileVersion: any) => ({
          ...fileVersion,
          revision: fileVersion.revision,
        }));

      setRevisions(allFileVersionRevisions.sort((a: any, b: any) => b.createdDate - a.createdDate));
    }
  }, [fileVersions]);

  const userAvatar = (userId: any) => <UserNameTagComponent id={userId} />;

  return (
    <div className="p-6 rounded-lg shadow-sm">
      {
        <div className="space-y-4">
          {revisions.map((revision: any, index: number) => (
            <div key={index} className="mb-4 last:mb-0">
              <div className="flex items-center justify-between mb-3">
                <span className="text-lg font-semibold">{revision.revision.value}</span>
                <span className="text-bold">V{revision.fileVersionNumber}</span>
              </div>

              <div className="flex items-center gap-2 text-sm">
                <span>{t("Created by")}</span>
                <div className="flex items-center">{userAvatar(revision.revision.createdBy)}</div>
                <span className="text-sm">{convertDate(Number(revision.revision.createdDate), "dateForText")}</span>
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

export default RevisionContent;
